import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'da';
    document.title = 'BILLEDKLAR™ – Færdige billedkunstlektioner til 1.–6. klasse';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mk83wrqn3zad">
      <div lang="da" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3rc9f0ac2njyt">
        <CountdownBar data-id="element-2" data-mp="3relu8fqg3g86" />
        <main data-id="element-3" data-mp="5opiv1o0k3w">
          <Hero data-id="element-4" data-mp="6817u0q2c9h" />
          <StatsBar data-id="element-5" data-mp="4n5w26l2pak" />
          <Difference data-id="element-6" data-mp="56lhc8rh1lf" />
          <Recognize data-id="element-7" data-mp="2zl3alhpbj03q" />
          <WhatsInside data-id="element-8" data-mp="2zllcouynw8jk" />
          <InsidePages data-id="element-9" data-mp="2zmeowbge3q93" />
          <Bonuses data-id="element-10" data-mp="2zmwlj96ys6hj" />
          <HowItWorks data-id="element-11" data-mp="33mouhn09senf" />
          <Audience data-id="element-12" data-mp="33m5ck6amdq9e" />
          <Offer data-id="element-13" data-mp="33nq9g2keplaf" />
          <Guarantee data-id="element-14" data-mp="33n6wl09m5n39" />
          <Testimonials data-id="element-15" data-mp="33oi2b5mmd4x0" />
          <Faq data-id="element-16" data-mp="38m1iwc6shts4" />
          <FinalCta data-id="element-17" data-mp="38li6tc3tlzm0" />
        </main>
        <Footer data-id="element-18" data-mp="38kgmsi4tu2s5" />
      </div>
    </MotionConfig>;
}